<template>
  <div class="home-box">
    <PageTitle :title="'Edit Zone'"></PageTitle>
    <v-row align="center">
      <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <div class="col-md-12 home-tabs-body">
        <EditForm></EditForm>
      </div>
    </v-row>
  </div>
</template>

<script>
import EditForm from "@/components/zone/EditForm";
import PageTitle from "@/components/shared/PageTitle";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Projects",
  components: {
    EditForm,
    PageTitle,
  },
  data: function () {
    return {
      role: localStorage.getItem('role') || null,
      editMode: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },

  watch: {
  }
};
</script>
